import React from 'react'
import { clsx } from 'clsx'

export type LinkProps = {
    className?: string
    style?: React.CSSProperties
    children?: React.ReactNode

    to?: string
    onClick?: HTMLButtonElement['click']
}

export default function Link({ className, children, ...others }: LinkProps) {
    return (
        <button className={clsx('button-as-link', className)} {...others}>
            {children}
        </button>
    )
}
